import React from "react";
import assetify from "@quintype/framework/assetify";
import DesktopLogo from "../../../../assets/images/NL-new-logo.svg";
import MobileLogo from "../../atoms/icons/mobile-logo";
import "./publihser-logo.m.css";
export function Logo() {
  return (
    <React.Fragment>
      <div className="desktop-only ">
        <img src={assetify(DesktopLogo)} loading="lazy" alt="Newslaundry" width="250px" />
      </div>
      <div className="mobile-only" styleName="logo-margin">
        <MobileLogo />
      </div>
    </React.Fragment>
  );
}
